<template>
  <b-form-group
    label="Choose geometry alias field"
    label-cols="3"
    :disabled="uploading"
  >
    <template slot="label">
      Choose geometry alias field <HelpTooltip title="The shapefile attribute that contains the geometry names" />
    </template>
    <b-select
      :value="value"
      :options="options"
      :state="state && null"
      @input="$emit('input', $event)"
    />
    <b-form-invalid-feedback :state="state && null">
      This field is required
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import HelpTooltip from '@/components/admin/upload/HelpTooltip.vue'

const components = {
  HelpTooltip,
}

const props = {
  v: {
    type: Object,
    required: true,
  },
  geom: {
    type: Object,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  uploading: {
    type: Boolean,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
}

@Component({ components })
export default class GeomConfig extends Vue.extend({ props }) {
  get state () {
    return this.v.$dirty ? !this.v.$error : null
  }
}

</script>
